import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { UserNotificationsPanel } from './UserNotificationsPanel';

export const UserNotificationsPanelBridge = react2angular(
  UserNotificationsPanel,
  ['onClose', 'onUnreadDismissed']
);
